"use strict";
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersetOmniService = void 0;
const app_consensus_1 = require("@branch-ts/app-consensus");
const debug_consensus_1 = require("@branch-ts/debug-consensus");
const omniCenter_1 = require("@branch-ts/practice-omni-web/src/omniCenter");
const omniCenterInspector_1 = require("@branch-ts/practice-omni-web/src/omniCenter/omniCenterInspector");
const puri_1 = require("@branch-ts/puri");
const web_consensus_1 = require("@branch-ts/web-consensus");
const feature_1 = require("./service.Verset/feature");
const service_VersetRequireLogin_1 = require("./service.VersetRequireLogin");
let VersetOmniService = (() => {
    let _classDecorators = [(0, app_consensus_1.service)()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    var VersetOmniService = class {
        static { _classThis = this; }
        constructor() {
            this.debug = debug_consensus_1.Debug.instance(this).tag("VersetOmniService");
            this.me = app_consensus_1.ServiceContext.about(this);
            this.deps = this.me.dependencies({
                VersetRequireLoginService: service_VersetRequireLogin_1.VersetRequireLoginService,
            });
        }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            VersetOmniService = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        async initialize() {
            const requireLoginService = this.deps.VersetRequireLoginService;
            const agreement = requireLoginService.agreement;
            const vendor = agreement.vendor;
            const editorKind = agreement.particulars.versetWebapp.verse.editorKind;
            this.editorKind = editorKind;
            const localStorageProvider = requireLoginService.localStorageProvider;
            const omniName = "VersetOmni";
            const omniCenter = omniCenter_1.OmniCenter.make({
                name: omniName,
                store: localStorageProvider,
            });
            this.omniCenter = omniCenter;
            this.unregisterLogout = web_consensus_1.LogoutMechanism.registerAction("Verset.omni", () => omniCenter.dispose(), { phase: "cleanup" });
            (0, feature_1.OmniExternalSourcesFeature)({
                owner: this,
                omniCenter,
            });
            const omniCenterURI = puri_1.PURI.build({
                vendor,
                protocol: "debug",
                kind: "ui",
                id: "omni-center",
            });
            web_consensus_1.PuriAppMechanism.register({
                name: "DebugOmniCenter",
                registry: (option) => {
                    if (option.uri !== omniCenterURI) {
                        return;
                    }
                    const omniCenterInspector = new omniCenterInspector_1.OmniCenterInspector();
                    omniCenterInspector.present.configure({
                        omniCenter,
                    });
                    return omniCenterInspector;
                },
            });
            (0, feature_1.OmniSearchHotkeysFeature)({
                omniCenter,
            });
            (0, feature_1.OmniEditorQuickInsertFeature)({
                editorKind,
                omniCenter,
            });
            await omniCenter.initialize();
            this.debug.log(`Omni setup completed for: ${omniName}`);
        }
        destroy() {
            this.unregisterLogout?.();
            this.omniCenter?.dispose();
        }
    };
    return VersetOmniService = _classThis;
})();
exports.VersetOmniService = VersetOmniService;
